import React, { useEffect, useState } from 'react';
import { ButtonWithLoadingIcon } from '../../../components/common/ButtonWithLoadingIcon';
import { RentalReturnStep2 } from './returnStep2';
import _ from 'lodash';
import { LoadingContainer } from '../../../components/common/LoadingContainer';

export const RentalReturnStep1 = ({ productList, onClickNext }) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showStep2, setShowStep2] = useState(false);
  const [error, setError] = useState(null);
  const [productListData, setProductListData] = useState([]);

  useEffect(() => {
    if (productList.length > 0) {
      const newData = _.groupBy(productList, 'order_number');
      setProductListData(newData);
    }
    setIsLoading(false);
  }, [productList]);

  const renderButton = () => {
    return (
      <div className={'review-button'}>
        <ButtonWithLoadingIcon
          style={{
            alignSelf: 'center',
            width: '35%',
            marginBottom: 10,
          }}
          type='submit'
          color={'primary'}
          onClick={() => {
            if (selectedProduct) {
              setShowStep2(true);
              setError(null);
            } else {
              setError('Please select a product');
            }
          }}
        >
          Next
        </ButtonWithLoadingIcon>
      </div>
    );
  };
  return (
    <div>
      {isLoading ? (
        <LoadingContainer />
      ) : productListData && Object.keys(productListData)?.length > 0 ? (
        Object.keys(productListData)?.map((order) => {
          return productListData[order].map((productData, index) => {
            return (
              <div
                style={{
                  marginBottom: index === productList.length - 1 ? 15 : 40,
                  marginLeft: '2.5rem',
                  marginRight: '2.5rem',
                }}
              >
                <div
                  className='d-flex flex-direction-row align-items-center'
                  style={{ justifyContent: 'space-between' }}
                >
                  <span style={{ fontFamily: 'Brown Bold' }}>
                    Order {order ? `#${order}` : '--'}
                  </span>
                  <span style={{ fontFamily: 'Brown Bold' }}>
                    Date ordered: {productData?.orderDate}
                  </span>
                </div>
                <div
                  className='d-flex list-view'
                  style={
                    selectedProduct === productData
                      ? { backgroundColor: '#F5E5D9' }
                      : {}
                  }
                  onClick={() => {
                    setError(null);
                    setSelectedProduct(productData);
                  }}
                >
                  {productData?.img_url ? (
                    <div
                      className={'mr-3'}
                      style={{ height: 170, width: 140, borderRadius: 8 }}
                    >
                      <img
                        src={productData.img_url}
                        alt={productData.title}
                        style={{
                          height: '100%',
                          width: '100%',
                          borderRadius: 8,
                        }}
                      />
                    </div>
                  ) : null}
                  <div style={{ marginTop: 8, width: '100%' }}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span style={{ fontFamily: 'Brown', fontSize: 20 }}>
                        {productData.brand.toUpperCase() || '--'}
                      </span>
                      <span style={{ fontFamily: 'Brown', fontSize: 20 }}>
                        {productData.id}
                      </span>
                    </div>
                    <span
                      className='mb-2'
                      style={{ fontFamily: 'Brown', fontSize: 20 }}
                    >
                      {productData.title || productData.product_title || ''}
                    </span>
                    <br />
                    <span>{`${productData?.size
                      ?.toString()
                      ?.toUpperCase()}/${productData?.color?.toUpperCase()}`}</span>
                    <div style={{ marginTop: 18 }}>
                      {productData.user_return_note ? (
                        <div
                          className={
                            'd-flex flex-direction-row align-items-center'
                          }
                        >
                          <span
                            style={{
                              fontFamily: 'Brown Bold',
                              marginRight: 6,
                              color: '#2E2B2B',
                            }}
                          >
                            Reason for return:
                          </span>
                          <span style={{ marginTop: 2, color: '#2E2B2B' }}>
                            {productData.user_return_note}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            );
          });
        })
      ) : (
        <div className='d-flex align-items-center justify-content-center h-100'>
          No product found for return
        </div>
      )}
      {showStep2 ? (
        <RentalReturnStep2
          visible={showStep2}
          toggle={() => setShowStep2(!showStep2)}
          handleClose={() => setShowStep2(false)}
          selectedProduct={selectedProduct}
          onNextClick={(selectedOption) => {
            setShowStep2(false);
            onClickNext({ selectedProduct, selectedOption });
          }}
        />
      ) : null}
      {error ? (
        <div style={{ display: 'flex', marginBottom: -25 }}>
          <span
            style={{
              fontSize: '14',
              color: '#F96E4E',
              fontFamily: 'Brown',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {error}
          </span>
        </div>
      ) : null}
      {renderButton()}
    </div>
  );
};
